import React from "react";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { RespectOrchestratorState } from "@nju/feature-sales-orchestrator";
import { ConsentsPage } from "@nju/feature-sales-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function Consents() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState mode={["ftth", "mobile"]} state="CONSENTS">
            <ConsentsPage />
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
